
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Punetorajshtan() {



    const cardData =
    {
        keyword: ' Pune to Rajasthan Cab',
        heading: 'Prince Cabs: Pune to Rajasthan Cab',
        headingDescription: 'Prince Cabs provides dependable Pune to Rajasthan Cab services, ideal for family vacations, business travel, pilgrimages, and long-distance tours. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable journey from Pune to Rajasthan’s top destinations like Jaipur, Udaipur, Jodhpur, and Jaisalmer. With professional chauffeurs, flexible schedules, and on-time pickups, we make your interstate travel hassle-free and enjoyable. Experience convenience, reliability, and affordability with Prince Cabs’ trusted cab service from Pune to Rajasthan.',

        top: 'Top Places to Visit in Rajasthan with Prince Cabs',

"topPlaces": [
  {
    "title": "Jaipur City Palace",
    "description": "Located in the heart of Jaipur, City Palace is a stunning blend of Rajput, Mughal, and European architecture. Built by Maharaja Sawai Jai Singh II, it houses courtyards, museums, and the royal residence. Highlights include the Mubarak Mahal, Chandra Mahal, and Peacock Gate. Visitors explore artifacts, royal costumes, and arms displays. The palace narrates Jaipur’s regal history with grandeur. It remains a cultural landmark of Rajasthan’s Pink City."
  },
  {
    "title": "Amber Fort",
    "description": "Amber Fort, a UNESCO World Heritage Site near Jaipur, is an architectural marvel overlooking Maota Lake. Built in red sandstone and marble, it features ornate palaces, halls, and courtyards. The Sheesh Mahal (Mirror Palace) is its highlight with dazzling mirror work. Elephant rides and light-and-sound shows enrich the experience. Its fusion of Hindu and Mughal architecture fascinates visitors. Amber Fort is one of Rajasthan’s crown jewels."
  },
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, or Palace of Winds, is Jaipur’s most iconic structure with its honeycomb-like façade of 953 windows. Built in 1799, it allowed royal ladies to view street processions without being seen. The palace’s pink sandstone structure glows beautifully at sunrise. Inside, small chambers and views of the city are captivating. It represents Jaipur’s architectural charm. Hawa Mahal is a must-visit for heritage lovers and photographers."
  },
  {
    "title": "Jodhpur Mehrangarh Fort",
    "description": "Mehrangarh Fort, rising 400 feet above Jodhpur, is one of India’s largest forts. Built by Rao Jodha in 1459, it has massive walls, palaces, and courtyards. The museum displays royal costumes, arms, and art collections. Panoramic views of Jodhpur’s blue houses from the fort are breathtaking. The fort also hosts cultural festivals and zip-lining adventures. Mehrangarh is a symbol of Jodhpur’s grandeur and power."
  },
  {
    "title": "Udaipur City Palace",
    "description": "Udaipur City Palace, built on the banks of Lake Pichola, is a masterpiece of marble and granite architecture. Its balconies, towers, and courtyards reflect Rajput grandeur. The palace complex includes museums, peacock mosaics, and royal chambers. Visitors enjoy boat rides offering stunning views of the palace from the lake. It is the largest palace complex in Rajasthan. City Palace is the pride of Udaipur, the ‘City of Lakes.’"
  },
  {
    "title": "Lake Pichola & Jag Mandir",
    "description": "Lake Pichola in Udaipur is a man-made freshwater lake surrounded by palaces and ghats. A boat ride here offers views of City Palace, Jag Mandir, and the iconic Lake Palace hotel. Jag Mandir Island Palace, known as the ‘Lake Garden Palace,’ enchants with its marble architecture. Sunset cruises on the lake are particularly magical. It is one of India’s most romantic destinations. Lake Pichola defines Udaipur’s charm."
  },
  {
    "title": "Jaisalmer Fort",
    "description": "Jaisalmer Fort, also called Sonar Quila or Golden Fort, is a UNESCO World Heritage Site built in 1156 AD. Made of yellow sandstone, it glows golden at sunrise and sunset. Unlike other forts, it is a living fort with shops, hotels, and homes inside. Visitors explore Jain temples, havelis, and narrow alleys. The fort narrates stories of Rajput valor and culture. It is Rajasthan’s desert jewel and a photographer’s delight."
  },
  {
    "title": "Sam Sand Dunes",
    "description": "Sam Sand Dunes near Jaisalmer offer the quintessential Thar Desert experience. Camel rides, jeep safaris, and desert camps with folk music and dance are major highlights. Sunsets here are breathtaking as the golden sands stretch endlessly. Tourists enjoy Rajasthani cuisine under starlit skies. The dunes come alive during the Desert Festival with cultural performances. Sam Sand Dunes make Jaisalmer unforgettable."
  },
  {
    "title": "Ranthambore National Park",
    "description": "Ranthambore National Park, near Sawai Madhopur, is one of India’s most famous tiger reserves. Spread across 1,300 sq. km, it is home to Bengal tigers, leopards, deer, and marsh crocodiles. Safaris take visitors deep into its forests and ruins of Ranthambore Fort. Birdwatchers spot hundreds of species here. The park combines nature and history with its ancient temples and lakes. Ranthambore is a paradise for wildlife enthusiasts."
  },
  {
    "title": "Pushkar Lake & Brahma Temple",
    "description": "Pushkar is one of the oldest towns in India, famous for its sacred Pushkar Lake and the rare Brahma Temple. Devotees believe a dip in the lake washes away sins. The temple dedicated to Lord Brahma is unique as very few exist worldwide. Pushkar is also known for its vibrant Camel Fair, attracting global tourists. The town’s ghats and markets add cultural charm. Pushkar blends spirituality with tradition beautifully."
  },
  {
    "title": "Mount Abu & Dilwara Temples",
    "description": "Mount Abu, Rajasthan’s only hill station, offers a cool retreat with scenic lakes and forests. The highlight here is the Dilwara Jain Temples, renowned for their marble carvings dating to the 11th century. Nakki Lake, Guru Shikhar, and Sunset Point add natural beauty. The temples’ intricate detailing is unmatched worldwide. Mount Abu combines spirituality with relaxation. It is a refreshing break in the desert state."
  },
  {
    "title": "Chittorgarh Fort",
    "description": "Chittorgarh Fort is the largest fort in India, covering 700 acres. It symbolizes Rajput bravery and sacrifice, being associated with legends of Rani Padmini and Maharana Pratap. The fort houses palaces, towers, temples, and reservoirs. The Vijay Stambh and Kirti Stambh are architectural highlights. Visitors explore tales of valor and jauhar here. Chittorgarh is Rajasthan’s ultimate heritage destination."
  },
  {
    "title": "Bikaner Junagarh Fort",
    "description": "Junagarh Fort in Bikaner, built in the 16th century, is one of the rare forts not built on a hill. Its massive structure includes ornate palaces, courtyards, and temples. The Anup Mahal and Phool Mahal are richly decorated with paintings and carvings. The fort museum displays artifacts of Bikaner’s royal past. Junagarh reflects Rajput grandeur and architectural finesse. It is a heritage gem of Rajasthan."
  },
  {
    "title": "Shekhawati Havelis",
    "description": "Shekhawati, known as the ‘Open Art Gallery of Rajasthan,’ is famous for its painted havelis and frescoes. Towns like Mandawa, Nawalgarh, and Jhunjhunu are dotted with heritage mansions. The intricate wall paintings depict mythological tales and daily life. Many havelis are converted into boutique hotels and museums. Photographers and art lovers find it enchanting. Shekhawati showcases Rajasthan’s artistic legacy."
  },
  {
    "title": "Ajmer Sharif Dargah",
    "description": "Ajmer Sharif Dargah is a revered Sufi shrine dedicated to Khwaja Moinuddin Chishti. Pilgrims of all faiths visit to seek blessings and peace. The dargah complex includes mosques, courtyards, and markets filled with devotional energy. Annual Urs Festival draws thousands of devotees. The dargah’s spiritual ambiance is deeply moving. It is one of Rajasthan’s most important pilgrimage sites."
  }
],

   "services": [
    {
      "name": "Pune to Jaipur Cab Booking",
      "description": "Book comfortable and reliable cab services from Pune to Jaipur. Enjoy a hassle-free journey in well-maintained vehicles such as Innova Crysta, Dzire, and Etios with professional drivers ensuring timely and safe travel."
    },
    {
      "name": "Pune to Jodhpur Cab",
      "description": "Travel from Pune to Jodhpur with affordable and premium cab options. Choose from spacious Innova Crysta or economical Dzire taxis, perfect for family trips, business travel, or sightseeing tours."
    },
    {
      "name": "Pune to Bikaner Cab Service",
      "description": "Experience convenient and comfortable cab service from Pune to Bikaner. Our reliable drivers and clean vehicles ensure a smooth long-distance journey with flexible packages tailored to your needs."
    },
    {
      "name": "Pune to Ajmer Cab",
      "description": "Book Pune to Ajmer cabs for a safe and comfortable ride. Ideal for pilgrims and tourists, our service offers spacious cars, courteous drivers, and competitive pricing for a stress-free trip."
    },
    {
      "name": "Pune to Kota Cab",
      "description": "Avail Pune to Kota cab service with well-maintained vehicles and professional chauffeurs. Perfect for outstation business or leisure trips, offering round trip and one-way packages."
    },
    {
      "name": "Pune to Alwar Cab",
      "description": "Reliable and affordable cab services from Pune to Alwar. Travel comfortably in sedans or SUVs with experienced drivers who prioritize your safety and convenience."
    },
    {
      "name": "Pune to Pali Cab Fare",
      "description": "Get competitive cab fare estimates for travel between Pune and Pali. Choose from multiple vehicle types including Innova Crysta and Dzire for your long-distance travel needs."
    },
    {
      "name": "Pune to Rajasthan Innova Crysta Taxi Fare",
      "description": "Luxury Innova Crysta taxi service from Pune to various Rajasthan destinations at affordable rates. Enjoy spacious seating, modern amenities, and a comfortable travel experience."
    },
    {
      "name": "Pune to Rajasthan Innova Cab",
      "description": "Book Innova cabs for your Pune to Rajasthan journey. Perfect for families and groups, with round trip options and reliable service across major cities like Jaipur, Jodhpur, and Udaipur."
    },
    {
      "name": "Pune to Rajasthan Dzire Taxi",
      "description": "Cost-effective Dzire taxi service from Pune to Rajasthan for solo travelers or small groups. Comfortable rides, professional drivers, and transparent pricing."
    },
    {
      "name": "Pune to Rajasthan Tour Cab",
      "description": "Explore Rajasthan with specially designed tour cab packages from Pune. Visit major tourist spots with expert drivers and comfortable vehicles for an unforgettable experience."
    },
    {
      "name": "Pune to Rajasthan Round Trip Taxi",
      "description": "Convenient round trip taxi services from Pune to Rajasthan with flexible packages. Ideal for tourists and business travelers seeking hassle-free transportation and quality service."
    },
    {
      "name": "Affordable Pune to Rajasthan Cab",
      "description": "Affordable and reliable cab services from Pune to Rajasthan. Choose from a range of vehicles and enjoy quality service without breaking your budget."
    },
    {
      "name": "Luxury Cab Pune to Rajasthan",
      "description": "Experience luxury cab services from Pune to Rajasthan with premium vehicles like Innova Crysta and professional chauffeurs. Perfect for travelers seeking comfort, style, and reliability."
    }
  ],
  "tableData": [
    ["Pune to Jaipur Cab Booking", "Pune to Jodhpur Cab"],
    ["Pune to Bikaner Cab Service", "Pune to Ajmer Cab"],
    ["Pune to Kota Cab", "Pune to Alwar Cab"],
    ["Pune to Pali Cab Fare", "Pune to Rajasthan Innova Crysta Taxi Fare"],
    ["Pune to Rajasthan Innova Cab", "Pune to Rajasthan Dzire Taxi"],
    ["Pune to Rajasthan Tour Cab", "Pune to Rajasthan Round Trip Taxi"],
    ["Affordable Pune to Rajasthan Cab", "Luxury Cab Pune to Rajasthan"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Rajasthan Cab Service",
        "WhyChoosedescription": "Prince Cabs offers dependable and comfortable cab services from Pune to various popular destinations in Rajasthan including Jaipur, Udaipur, Jodhpur, and Ajmer. Whether you're traveling for leisure, pilgrimage, or business, our service ensures a safe, stress-free long-distance journey with well-maintained vehicles and professional drivers."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles for Long Journeys",
        "WhyChoosedescription": "Our fleet includes a range of sedans and SUVs such as Swift Dzire, Innova, and more, all designed for comfort on extended trips. With ample legroom, luggage space, and air conditioning, our vehicles help make your long ride from Pune to Rajasthan enjoyable and relaxing."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Expertise in Long-Distance Routes",
        "WhyChoosedescription": "Our professional drivers are skilled in navigating the highways and byways between Pune and Rajasthan’s major cities. They prioritize safety, timely breaks, and efficient route planning to ensure you arrive refreshed and on schedule."
    },
    {
        "WhyChooseheading": "Flexible Booking Options to Match Your Travel Plans",
        "WhyChoosedescription": "Prince Cabs offers customizable rental packages including one-way trips, round trips with waiting periods, and multi-day tours covering various Rajasthan destinations. Bookings can be made easily through phone, WhatsApp, or online with instant confirmation."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our pricing is clear and competitive, covering all essential costs such as fuel, tolls, driver allowances, and taxes. Multiple secure payment methods are available, including UPI, credit/debit cards, net banking, and cash, ensuring convenience and trust."
    },
    {
        "WhyChooseheading": "Sanitized and Well-Maintained Vehicles for Your Safety",
        "WhyChoosedescription": "Each cab undergoes rigorous cleaning and sanitization before and after every trip, ensuring a hygienic and safe environment. Regular maintenance checks guarantee mechanical reliability, while safety features like seat belts and airbags enhance passenger protection."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Travel",
        "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, itinerary changes, or any travel concerns, making your Pune to Rajasthan cab experience smooth, comfortable, and worry-free."
    }
]




























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab service from Pune to Rajasthan?',
        answer: 'Yes, Prince Cabs offers comfortable and reliable cab services from Pune to various cities in Rajasthan such as Jaipur, Udaipur, Jodhpur, and more.',
    },
    {
        question: 'What types of vehicles are available for Pune to Rajasthan trips?',
        answer: 'We provide a variety of vehicles including Swift Dzire, Innova, and Tempo Traveller to suit solo travelers, families, and larger groups.',
    },
    {
        question: 'How long does the journey from Pune to Rajasthan take?',
        answer: 'Travel time varies depending on the city but typically ranges from 18 to 22 hours, depending on traffic and route conditions.',
    },
    {
        question: 'Can I book a round-trip cab from Pune to Rajasthan?',
        answer: 'Absolutely! Prince Cabs offers flexible one-way and round-trip packages tailored to your travel schedule and requirements.',
    },
    {
        question: 'Are the cabs sanitized and maintained for long-distance travel?',
        answer: 'Yes, all vehicles are regularly serviced and sanitized to ensure passenger safety and comfort throughout the journey.',
    },
    {
        question: 'What are the approximate fares for Pune to Rajasthan cab service?',
        answer: 'Fares vary based on vehicle type, distance, and duration. Please contact Prince Cabs for a personalized quote and competitive pricing.',
    },
    {
        question: 'How do I book a cab from Pune to Rajasthan?',
        answer: 'You can book easily via our website or by calling our customer service with your travel details for quick confirmation and assistance.',
    },
];

const testimonials = [
    {
        name: "Mr. Sanjay Singh",
        position: "Tourist",
        text: "I booked a cab from Pune to Jaipur with Prince Cabs. The service was excellent, the car was comfortable, and the driver was very professional.",
        image: "/img/testimonial/testimonial-thumb-rajasthan-1.png",
    },
    {
        name: "Ms. Priya Sharma",
        position: "Family Traveler",
        text: "Our Pune to Udaipur trip with Prince Cabs was wonderful. The vehicle was clean, and the driver was courteous and knowledgeable about the route.",
        image: "/img/testimonial/testimonial-thumb-rajasthan-2.png",
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Pune to Rajasthan Cab",
  "description": "Reliable and affordable cab services from Pune to various cities in Rajasthan including Jaipur, Jodhpur, Bikaner, Ajmer, Kota, Alwar, and Pali. Options for Innova Crysta, Dzire, family cabs, and luxury tours available.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Pune to Jaipur Cab Booking",
    "Pune to Jodhpur Cab",
    "Pune to Bikaner Cab Service",
    "Pune to Ajmer Cab",
    "Pune to Kota Cab",
    "Pune to Alwar Cab",
    "Pune to Pali Cab Fare",
    "Pune to Rajasthan Innova Crysta Taxi Fare",
    "Pune to Rajasthan Innova Cab",
    "Pune to Rajasthan Dzire Taxi",
    "Pune to Rajasthan Tour Cab",
    "Pune to Rajasthan Round Trip Taxi",
    "Affordable Pune to Rajasthan Cab",
    "Luxury Cab Pune to Rajasthan"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Pune to Rajasthan Cab | Jaipur, Jodhpur, Bikaner Taxi Service</title>
  <meta
    name="description"
    content="Reliable and affordable cab services from Pune to Jaipur, Jodhpur, Bikaner, Ajmer, Kota, Alwar, and Pali. Book Innova Crysta, Dzire, family cabs, and luxury tour packages."
  />
  <meta
    name="keywords"
    content="Pune to Jaipur Cab Booking, Pune to Jodhpur Cab, Pune to Bikaner Cab Service, Pune to Ajmer Cab, Pune to Kota Cab, Pune to Alwar Cab, Pune to Pali Cab Fare, Pune to Rajasthan Innova Crysta Taxi Fare, Pune to Rajasthan Innova Cab, Pune to Rajasthan Dzire Taxi, Pune to Rajasthan Tour Cab, Pune to Rajasthan Round Trip Taxi, Affordable Pune to Rajasthan Cab, Luxury Cab Pune to Rajasthan"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetorajshtan ;